/*jslint node: true */
/*globals $ */
'use strict';

import components from './components.js';
import tools from './tools.js';
import $ from 'jquery';

export function disableRegisterButton() {
  const registerForm = document.getElementById('register-ol');

  registerForm.addEventListener('submit', (event) => {
    event.preventDefault();
    const registerButton = registerForm.querySelector('input[type="submit"]');
    registerButton.value = 'Rekisteröidään...';
    registerButton.disabled = true;
    registerForm.submit();
  });
}

function closeInfobox () {
  const closeButton = document.querySelector('.omalaakkonen-app .infobox .hedin-btn');

  closeButton.addEventListener('click', (event) => {
    event.preventDefault();
    const infobox = document.querySelector('.omalaakkonen-app .infobox');
    infobox.style.display = 'none';
    localStorage.setItem('infoboxClosed', 'true');
  });
}

function hideInfobox() {
  const infobox = document.querySelector('.omalaakkonen-app .infobox');
  if (localStorage.getItem('infoboxClosed')) {
    infobox.style.display = 'none';
  }
}

function login(loginForm, callback) {

  var username = loginForm.find('input[name="username"]').val();
  var password = loginForm.find('input[name="password"]').val();

  tools.getToken(function (token) {
    $.ajax({
      type: 'POST',
      dataType: 'json',
      url: '/ajax/login/',
      cache: false,
      data: {
        username: username,
        password: password,
        token: token
      },
      success: function (data) {
        if (callback && typeof callback === 'function') {
          callback(data);
        }
      }
    });
  });

}

function logout(callback) {

  tools.getToken(function (token) {
    $.ajax({
      type: 'POST',
      dataType: 'json',
      url: '/ajax/logout/',
      data: {
        token: token
      },
      success: function (data) {
        if (callback && typeof callback === 'function') {
          callback(data);
        }
      }
    });
  });

}

function onScroll() {

  if ($('.omalaakkonen-app').length > 0 && $('footer.v10').length > 0) {

    var start, end, bottom;

    if ($(window).width() > 768 && $('.sidenav').length > 0) {

      var $sidenav = $('.sidenav').eq(1).find('ul');

      start = Math.floor($('.app-router-view').offset().top) + 3;
      end = $('footer.v10').offset().top;
      bottom = $(window).scrollTop() + $sidenav.outerHeight();

      if (bottom >= end) {
        $sidenav.css({
          top: 'auto',
          bottom: $(window).height() - (end - $(window).scrollTop()),
        });
      } else if (start - $(window).scrollTop() > 0) {
        $sidenav.css({
          top: start - $(window).scrollTop(),
          bottom: 'auto',
        });
      } else {
        $sidenav.css({
          top: 0,
          bottom: 'auto',
        });
      }
    } else if ($('.sidenav').length > 0) {
      var $mobilenav = $('.mobilenav');
      start = Math.floor($('#root').offset().top);
      end = $('footer.v10').offset().top;
      bottom = $(window).scrollTop() + $mobilenav.outerHeight();

      if (bottom >= end) {
        $mobilenav.css({
          top: 'auto',
          bottom: $(window).height() - (end - $(window).scrollTop()),
        });
      } else if (start - $(window).scrollTop() > 0) {
        $mobilenav.css({
          top: start - $(window).scrollTop(),
          bottom: 'auto',
        });
      } else {
        $mobilenav.css({
          top: 0,
          bottom: 'auto',
        });
      }

    }
  }

}

function init() {
  var userReportsHolder = $('.testdrive-reports-holder')
    .length > 0 ? $('.testdrive-reports-holder') : false;

  if (userReportsHolder) {

    var $loader = $('<div class="loader normal" />')
      .css({
        margin: '20px auto'
      });

    userReportsHolder.html($loader);

    tools.getToken(function (token) {

      $.get('/stage-ajax/get-testdrive-reports?token=' + token, function (data) {

        if (data.success) {

          var html = '';

          $.each(data.reports, function (i, report) {

            html += '<div class="col-md-5">';
            html += '<p class="nomargin text-uppercase">' + report.license + '</p>';
            html += '<h3 class="uppercase margin-bottom-10"><strong>';
            html += (report.make ? report.make : report.brand) + ' ' + report.model + ' ' + report.model_sub_category + '</strong> ' + report.model_year + '</h3>';
            html += '<p class="grade">';

            var gradeTotal = 5;

            for (var j = 0; j < report.grade; j++) {

              html += '<i class="fa fa-star"></i> ';
              gradeTotal--;

            }

            for (j = 0; j < gradeTotal; j++) {
              html += '<i class="fa fa-star-o"></i> ';
            }

            html += '</p>';
            html += '<p>' + report.report + '</p>';
            html += '</div>';

          });

          userReportsHolder.html(html);

        } else
          userReportsHolder.html('<div class="col-md-10"><p>Koeajoraportteja ei löytynyt.</p></div>');


      }, 'JSON');

    });

  }

  var reportHolder = $('.testdrive-report')
    .length > 0 ? $('.testdrive-report') : false;

  if (reportHolder) {

    var reportHolderModels = reportHolder.find('select[name="model"]')
      .length > 0 ? reportHolder.find('select[name="model"]') : false;

    if (reportHolderModels) {

      var reportHolderModelsObj = {};
      $.each(reportHolderModels.find('optgroup'), function () {
        var self = $(this);
        reportHolderModelsObj[self.attr('label')] = [];
        $.each(self.find('option'), function () {
          var model = $(this);
          reportHolderModelsObj[self.attr('label')].push(model.val());
        });
      });

      reportHolder.find('select[name="make"]')
        .change(function () {
          var tmpl = '';
          var self = $(this);
          $.each(reportHolderModelsObj[self.val()], function (i, model) {
            tmpl += '<option value="' + model + '">' + model + '</option>';
          });
          reportHolderModels.html(tmpl);
        });

    }

    var setReportStars = function (val) {

      $('label.grade')
        .removeClass('active');
      $('label.grade')
        .find('.fa')
        .addClass('fa-star-o')
        .removeClass('fa-star');

      for (var i = 1; i <= val; i++) {
        $('label.grade[data-id="' + i + '"]')
          .addClass('active');
        $('label.grade[data-id="' + i + '"]')
          .find('.fa')
          .removeClass('fa-star-o')
          .addClass('fa-star');
      }

    };

    reportHolder.find('input[type="radio"][name="grade"]')
      .click(function () {
        var self = $(this);
        var val = self.val();
        setReportStars(val);
      });

    $('label.grade')
      .hover(function () {
        var self = $(this);
        var val = self.find('input')
          .val();
        setReportStars(val);
      });

    $('label.grade')
      .parent('div')
      .mouseleave(function () {
        var val = $('input[type="radio"][name="grade"]:checked')
          .val();
        setReportStars(val);
      });

    reportHolder.find('select.car')
      .change(function () {

        var self = $(this)
          .find('option:selected');

        reportHolder.find('input[type="hidden"][name="make"]')
          .val(self.attr('data-make'));
        reportHolder.find('input[type="hidden"][name="model"]')
          .val(self.attr('data-model'));
        reportHolder.find('input[type="hidden"][name="year"]')
          .val(self.attr('data-year'));
        reportHolder.find('input[type="hidden"][name="drive_date"]')
          .val(self.attr('data-drivedate'));
        reportHolder.find('input[type="hidden"][name="specific"]')
          .val(self.attr('data-specific'));
        reportHolder.find('input[type="hidden"][name="vid"]')
          .val(self.attr('data-vid'));
        reportHolder.find('input[type="hidden"][name="license"]')
          .val(self.attr('data-license'));

      });

    reportHolder.find('form')
      .submit(function (e) {

        e.preventDefault();
        var self = $(this);
        self.find('input[type="submit"]')
          .prop('disabled', true);

        if ($('input[type="radio"][name="grade"]:checked')
          .length < 1) {
          components.popup('<p>Anna arvosana.</p>');
          self.find('input[type="submit"]')
            .prop('disabled', false);
        } else if ($('select.car')
          .val() === '') {
          components.popup('<p>Valitse auto.</p>');
          self.find('input[type="submit"]')
            .prop('disabled', false);
        } else {

          tools.getToken(function (token) {

            $.post('/stage-ajax/add-testdrive-report/?token=' + token, self.serialize(), function (data) {

              if (data.status) {
                components.popup('<p>' + data.msg + '</p>');
                location.href = '/omalaakkonen/';
              } else
                components.popup('<p>' + data.msg + '</p>');

              setTimeout(function () {

                if (self.find('.stage-error:not(.select)')
                  .length > 0)
                  self.find('input[type="submit"]')
                    .prop('disabled', false);

              }, 2000);

            }, 'json');

          });

        }

      });

  }

}

export default {
  login,
  logout,
  onScroll,
  closeInfobox,
  hideInfobox,
  init
};
